import { API_URL, apiGet } from './api';

export interface ApkPresignedResponse {
  url: string;
  expiresInSeconds: number;
}

/**
 * Pide a la API una URL GET prefirmada (S3 privado). Requiere JWT (página Preferencias → Apps).
 */
export async function fetchApkPresignedUrl(
  variant: 'interna' | 'externa',
): Promise<ApkPresignedResponse> {
  const path = variant === 'interna' ? 'presigned/interna' : 'presigned/externa';
  return apiGet(`${API_URL}/api/Apk/${path}`);
}
